import {Component, OnInit, PLATFORM_ID, Inject, OnDestroy, Injector, HostListener, ViewChild, ElementRef} from '@angular/core';
import {Router, NavigationEnd, NavigationStart} from '@angular/router';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {Subscription} from 'rxjs/Subscription';
import {LangService} from './Services/lang/lang.service';
import {IpService} from './Services/ip/ip.service';
import {ModalService} from './Services/modal/modal.service';
import {HeaderService} from './Services/header/header.service';
import {FooterService} from './Services/footer/footer.service';
import {environment} from '../environments/environment';
import {SlackService} from './Services/slack/slack.service';
import {ConfigService} from './Services/config/config.service';
import { AirportsService } from './Services/airports/airports.service';
import {TransferState, makeStateKey} from '@angular/platform-browser';
import {AuthenticationService} from './Services/authentication/authentication.service';
import {OnboardingService} from './Services/onboarding/onboarding.service';
import {routesAnimation, footerAnimation} from './Animations/route-animation';
import {WINDOW} from './Services/window/window.service';
import {AnalyticsService} from './Services/analytics/analytics.service';
import {FiltersService} from './Services/filters/filters.service';
import {LuckyService} from './Services/lucky/lucky.service';
import { MixpanelService } from './Services/mixpanel/mixpanel.service';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

const serverCountryStateKey = makeStateKey('country');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routesAnimation, footerAnimation]
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'LuckyTrip';
    private popupOpenSubscription: Subscription;
    private popupCloseSubscription: Subscription;
    private initializeSubscription: Subscription;
    private statusChangeSubscription: Subscription;
    private revokeChoiceSubscription: Subscription;
    private noCookieLawSubscription: Subscription;
    private numofPages = 0;
    private serverCountry;
    private authSubscriber: Subscription;
    private configsSubscriber: Subscription;
    private airportsSubscriber;
    private routerSubscriber: Subscription;
    private logoutSubscriber: Subscription;
    public windowHeight;
    @ViewChild('modalContainer') modalContainer: ElementRef;
    private getIPSubscriber;
    geoLocation = null;
    geoCountry = '';
    private configsResponse = false;
    private airportsResponse = false;
    private selectedCountryCode;
    private selectedLanguageCode;

    private tokenSubscription = new Subscription()
    private timeout;

    constructor(private router: Router, private slaask: SlackService,
                @Inject(PLATFORM_ID) private platform: Object,
                @Inject(WINDOW) private window: Window,
                private lang: LangService,
                private ip: IpService,
                private header: HeaderService,
                private footer: FooterService,
                private ccService: NgcCookieConsentService,
                private translate: TranslateService,
                private injector: Injector,
                private config: ConfigService,
                private airportsService: AirportsService,
                private state: TransferState,
                private authService: AuthenticationService,
                private modalService: ModalService,
                private onboarding: OnboardingService,
                private analytics: AnalyticsService,
                private filtersService: FiltersService,
                private luckyService: LuckyService,
                private mixpanel: MixpanelService) {
        this.lang.initLang();
        this.slaask.identifySlaask(this.router.url);
        this.slaask.addSlaaskChatLoaderFile();
        let CSStorage;
        if (isPlatformBrowser(this.platform)) {
            CSStorage = localStorage.getItem('coockieConsent');
            if (CSStorage) {
                CSStorage = JSON.parse(CSStorage);
            }
        }

        this.routerSubscriber = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                const navUrl = event.url;
                if (navUrl.indexOf('checkout') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        if (document.getElementById('loader')) {
                            document.getElementById('loader').style.display = 'block';
                        }
                    }
                }
                if (isPlatformBrowser(this.platform)) {
                    document.querySelector('html').classList.remove('mainTripScreen');
                    document.querySelector('html').classList.remove('checkoutScreen');
                }
                if (navUrl.indexOf('trip') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        document.querySelector('html').classList.add('mainTripScreen');
                    }
                }
                if (navUrl.indexOf('checkout') > 0 || navUrl.indexOf('checkouts') > 0 || navUrl.indexOf('user') > 0 ||
                    navUrl.indexOf('privacy_policy') > 0 || navUrl.indexOf('privacy-policy') > 0 || navUrl.indexOf('terms') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        document.querySelector('html').classList.add('checkoutScreen');
                    }
                } else if (navUrl.indexOf('our-promise') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        document.querySelector('html').classList.add('ourPromiseScreen');
                    }
                } else if (navUrl.indexOf('traffic-light') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        document.querySelector('html').classList.add('trafficLightScreen');
                    }
                } else if (navUrl.indexOf('post') > 0) {
                    if (isPlatformBrowser(this.platform)) {
                        document.querySelector('body').classList.add('x-overflow');
                    }
                }
            }

            if (event instanceof NavigationEnd) {
                this.numofPages++;
                if (this.numofPages > 1 || (CSStorage && CSStorage.dismissed)) {
                    if (isPlatformBrowser(this.platform)) {
                        try {
                            this.ccService.close(false);
                        } catch (e) {
                            console.warn(e);
                        }
                    }

                }
                this.slaask.updateSlaaskContact();
                // this.analytics.logEvent('page_view');
                const navUrl = event.url;
                if (navUrl.indexOf('checkout') > 0) {
                    this.slaask.reloadLoader();
                }
                setTimeout(function () {
                    if (isPlatformBrowser(this.platform)) {
                        if (document.getElementById('loader')) {
                            document.getElementById('loader').classList.add('loaded');
                            setTimeout(function () {
                                if (document.getElementById('loader')) {
                                    document.getElementById('loader').remove();
                                }
                                document.getElementsByTagName('html')[0].style.backgroundColor = 'transparent';
                            }, 600);
                        }
                    }
                }.bind(this), 1000);
            }
        });
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            const modalContainerDisplayStatus = this.modalContainer.nativeElement.style.display;
            if (modalContainerDisplayStatus !== 'none') {
                this.modalService.overlayClicked(event);
            }
        }
    }

    onActivate(event) {
    }

    iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platform)) {
            this.windowHeight = this.window.innerHeight;

            this.getIPGeolocation();

            this.config.resetUserLuckyConfig();
            const userDefaultCountry = this.config.getUserDefaultCountry() ? this.config.getUserDefaultCountry().country_code : 'GB';
            this.serverCountry = this.state.get(serverCountryStateKey, userDefaultCountry ? userDefaultCountry : 'GB' as any);
            this.config.setUserCountry(userDefaultCountry ? userDefaultCountry : this.serverCountry);
            this.configsSubscriber = this.config.getConfigurations(userDefaultCountry ? userDefaultCountry : this.serverCountry)
                .subscribe((res) => {
                }, (err) => console.log(err));

            this.checkUserToken();
            this.handleLastVisit();
            this.analytics.setUserProperties();
            this.analytics.logEvent('app_open');

            this.mixpanel.init(environment.mixpanel.debug);
        }
        if (isPlatformServer(this.platform)) {
            this.config.serverCountry = this.injector.get('country');
            this.serverCountry = this.state.set(serverCountryStateKey, this.injector.get('country') as any);
        }
        this.header.isSolidBg(false);
        this.header.headerBGChangeAble(true);
        this.header.showMainNav(true);
        this.header.hasNoHeader(false);
        this.header.tripHeader(false);
        this.header.title(null);
        this.header.secondTitle(null);
        this.header.class('');
        this.footer.isSlaaskEnabled(true);
        this.footer.footerVisibility(true);
        if (isPlatformBrowser(this.platform)) {
            this.translate.stream(['strings.app.consentCookie.message', 'strings.app.consentCookie.link']).subscribe((text: string) => {
                this.ccService.getConfig().content = this.ccService.getConfig().content || {};
                this.ccService.getConfig().content.message = text['strings.app.consentCookie.message'];
                this.ccService.getConfig().content.link = text['strings.app.consentCookie.link'];
                this.ccService.destroy();
                this.ccService.init(this.ccService.getConfig());
            });
            this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
                () => {
                    localStorage.setItem('coockieConsent', '{"dismissed": true}');
                });
        }
        if(this.iOS()){
            $('body').addClass('ios')
        }
    }

    getIPGeolocation() {
        this.getIPSubscriber = this.ip.IPGeoLocation().subscribe(
            (value: any) => {
                this.geoLocation = value;
                this.geoCountry = value.country;

                this.config.resetUserLuckyConfig();

                if (this.geoLocation.countryCode == 'DE') {
                    this.selectedCountryCode = 'DE';
                    this.selectedLanguageCode = 'de';
                } else {
                    this.selectedCountryCode = 'GB';
                    this.selectedLanguageCode = 'en';
                }

                this.translate.use(this.selectedLanguageCode);
                localStorage.setItem('userDefaultLang', this.selectedLanguageCode);
                this.config.setUserCountry(this.selectedCountryCode);
                this.configsSubscriber = this.config.getConfigurations(this.selectedCountryCode).subscribe(
                    res => {
                        this.configsResponse = true;
                        this.updateCountryAirports(this.selectedCountryCode);
                    },
                    err => {
                        console.log(err);
                    }
                );
            },
            err => {
                console.log(err);
            }
        );
    }

    updateCountryAirports(cc) {
        this.airportsSubscriber = this.airportsService.getAirports(cc, null, null, null, this.translate.currentLang).subscribe(
            res => {
                this.airportsResponse = true;
                this.validateCountrySelection();
            },
            err => {
                console.log(err);
            }
        );
    }

    validateCountrySelection() {
        if (this.configsResponse && this.airportsResponse) {
            this.filtersService.storeSelectedAirports([this.filtersService.getUserCountry().airport.iata_code]);
            this.luckyService.invalidateCachedTrip();
            // this.userDefaultCountryObj = this.filtersService.getUserCountry();
            // this.selectedAirports = JSON.parse(JSON.stringify(this.filtersService.getSelectedAirports()));
        }
    }

    ngOnDestroy() {
        // unsubscribe to cookieconsent observables to prevent memory leaks
        // this.popupOpenSubscription.unsubscribe();
        if (isPlatformBrowser(this.platform)) {
            this.popupCloseSubscription.unsubscribe();
        }
        // this.initializeSubscription.unsubscribe();
        // this.statusChangeSubscription.unsubscribe();
        // this.revokeChoiceSubscription.unsubscribe();
        // this.noCookieLawSubscription.unsubscribe();
        if (this.authSubscriber) {
            this.authSubscriber.unsubscribe();
        }
        if (this.configsSubscriber) {
            this.configsSubscriber.unsubscribe();
        }
        if (this.airportsSubscriber) {
            this.airportsSubscriber.unsubscribe();
        }
        if (this.routerSubscriber) {
            this.routerSubscriber.unsubscribe();
        }
        if (this.logoutSubscriber) {
            this.logoutSubscriber.unsubscribe();
        }
        if (this.getIPSubscriber) {
            this.getIPSubscriber.unsubscribe();
        }
    }

    refreshTokenTimeout(token){
        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        const dateNow = (Math.floor((new Date).getTime() / 1000));
        const timeout = ((expiry - dateNow) * 1000) - 60000;
        
        return timeout;
    }

    refreshToken(token){
        this.tokenSubscription.unsubscribe();
        this.tokenSubscription = of(null).pipe(delay(this.refreshTokenTimeout(token))).subscribe((expired) => {
            console.log('EXPIRED!!');
            this.mixpanel.track('checkout_error', {
                token: token,
                
                reason: 'User token is EXPIRED!'
            });
            this.authService.refreshToken().subscribe(res => {
                this.refreshToken(res['token']);
            });
        });
    }

    checkUserToken() {
        debugger
        // const token  = this.authService.getUserToken();
        // this.refreshToken(token);
        

        // if (this.authService.isLoggedIn()) {
        //     this.authSubscriber = this.authService.getUser(this.authService.getUserToken()).subscribe(
        //         (res) => {
        //             // do nothing
        //         }, (error) => {
        //             this.logoutSubscriber = this.authService.logout().subscribe(
        //                 res => {
        //                     localStorage.removeItem('user');
        //                     localStorage.removeItem('token');
        //                 },
        //                 err => {
        //                     localStorage.removeItem('user');
        //                     localStorage.removeItem('token');
        //                 }
        //             );
        //         }
        //     );
        // }
    }

    handleLastVisit() {
        let lastVisitObj: any = localStorage.getItem('lastVisit');
        if (lastVisitObj) {
            lastVisitObj = JSON.parse(lastVisitObj);
            const lastVisitDate = lastVisitObj.date;
            const lastVisitDifference = moment().diff(moment(lastVisitDate), 'months', true);
            if (lastVisitDifference >= 1) {
                this.onboarding.isOnboardingActive = true;
            }
        }
        localStorage.setItem('lastVisit', '{"date": ' + moment() + '}');
    }

    overlayClicked(e) {
        this.modalService.overlayClicked(e);
    }
}
